import { Children, FunctionComponent, ReactElement, cloneElement } from 'react'

import { IGenericComponentProps } from './types'

const GenericCloneComponent: FunctionComponent<IGenericComponentProps> = ({
  children,
  propsMapper,
}) => {
  const childrenWithProps = Children.map(
    children,
    (child: ReactElement, index: number) => {
      const additionalProps = propsMapper(index)

      const clonedChild = cloneElement(child, {
        ...additionalProps,
      })

      return clonedChild
    },
  )

  return <>{childrenWithProps}</>
}

export default GenericCloneComponent
